/**
 * @generated SignedSource<<aa918c22111c919b1700b9a9405f7dce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExperienceSummary_User$data = {
  readonly profile: {
    readonly totalExperience: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ExperienceSummary_User";
};
export type ExperienceSummary_User$key = {
  readonly " $data"?: ExperienceSummary_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSummary_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSummary_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalExperience",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "44382ff52f99dab941fb65666fd8c5bb";

export default node;
